import DesignTokens from '@customink/design-tokens/build/js/designTokens';

export const spacing2 = '2px';
export const spacing4 = '4px';
export const spacing8 = DesignTokens.spacing[8].value;
export const spacing12 = '12px';
export const spacing16 = DesignTokens.spacing[16].value;
export const spacing20 = '20px';
export const spacing24 = `calc(${DesignTokens.spacing[16].value} + ${DesignTokens.spacing[8].value})`;
export const spacing32 = DesignTokens.spacing[32].value;
export const spacing40 = '40px';
export const spacing42 = '42px';
export const spacing48 = DesignTokens.spacing[48].value;
export const spacing56 = DesignTokens.spacing[56].value;
export const spacing60 = '60px';
export const spacing88 = '88px';
export const spacing282 = '282px';

export const sizing88 = '88px';
export const sizing120 = '120px';
export const sizing128 = '128px';
export const sizing140 = '140px';
export const sizing150 = '150px';
export const sizing160 = '160px';

export const fontSize13 = '13px';

export const bold = DesignTokens.typography.heading.sub.fontWeight.value;
export const fontSize = DesignTokens.typography.body.long1.size.value;
export const lineHeight = DesignTokens.typography.body.long1.lineHeight.value;
export const h6FontSize = DesignTokens.typography.heading.h6.size.value;
export const h6LineHeight = DesignTokens.typography.heading.h6.lineHeight.value;
export const fontFamily = `${DesignTokens.typography.family.value}, Helvetica, Arial, 'Trebuchet MS', sans-serif;`;

export const proofBackground = DesignTokens.color.background.productImage.value;
export const textColor = DesignTokens.color.text.primary.value;

export const colorSmoke = 'rgba(0, 0, 0, 0.11)';
export const colorLightGrey = '#F8F8F8';
export const colorGrayAccent = DesignTokens.color.gray.accent.value;
export const colorGraySlateDefault = DesignTokens.color.gray.slateDefault.value;
export const colorGrayObsidian = DesignTokens.color.gray.obsidian.value;
export const colorPurple = DesignTokens.color.purple.default.value;
export const colorWhite = DesignTokens.color.shade.white.value;
export const themeColor = DesignTokens.color.primary.active.value;
export const tertiaryColor = DesignTokens.color.tertiary.default.value;
export const colorBlue = DesignTokens.color.blue.default.value;
export const colorRed = DesignTokens.color.red.default.value;
export const colorDarkRed = DesignTokens.color.red.active.value;
export const colorBrown = '#54301a';

// Pigment Color Tokens

// lv. 1 primitives
export const PgmntColorBlack100 = 'rgba(0, 0, 0, 0.05)';
export const PgmntColorBlack200 = 'rgba(0, 0, 0, 0.11)';
export const PgmntColorBlack300 = 'rgba(0, 0, 0, 0.18)';
export const PgmntColorBlack400 = 'rgba(0, 0, 0, 0.28)';
export const PgmntColorBlack500 = 'rgba(0, 0, 0, 0.41)';
export const PgmntColorBlack600 = 'rgba(0, 0, 0, 0.57)';
export const PgmntColorBlack700 = 'rgba(0, 0, 0, 0.71)';
export const PgmntColorBlack800 = 'rgba(0, 0, 0, 0.79)';
export const PgmntColorBlack900 = 'rgba(0, 0, 0, 0.86)';
export const PgmntColorGray000 = '#ffffff';
export const PgmntColorGray050 = '#fbfbfb';
export const PgmntColorGray100 = '#f5f5f5';
export const PgmntColorGray200 = '#e3e3e3';
export const PgmntColorGray300 = '#d1d1d1';
export const PgmntColorGray400 = '#b8b8b8';
export const PgmntColorGray500 = '#969696';
export const PgmntColorGray600 = '#6e6e6e';
export const PgmntColorGray700 = '#4a4a4a';
export const PgmntColorGray800 = '#363636';
export const PgmntColorGray900 = '#242424';
export const PgmntColorBlue100 = 'rgba(30, 57, 210, 0.05)';
export const PgmntColorBlue200 = 'rgba(30, 57, 210, 0.15)';
export const PgmntColorBlue300 = 'rgba(30, 57, 210, 0.22)';
export const PgmntColorBlueDefault = '#1e39d2';
export const PgmntColorBlueDark = '#182ea8';
export const PgmntColorRed100 = 'rgba(250, 60, 0, 0.09)';
export const PgmntColorRed200 = 'rgba(250, 60, 0, 0.19)';
export const PgmntColorRed300 = 'rgba(250, 60, 0, 0.29)';
export const PgmntColorRedDefault = '#FA3C00';
export const PgmntColorRedDark = '#C83000';
export const PgmntColorRedAccessible = '#E03600';
export const PgmntColorFeedbackBlueDefault = '#0043ce';
export const PgmntColorFeedbackBlue100 = 'rgba(0, 69, 206, 0.08)';
export const PgmntColorFeedbackGreenDefault = '#198038';
export const PgmntColorFeedbackGreen100 = 'rgba(25, 128, 56, 0.10)';
export const PgmntColorFeedbackGreenAccessible = '#187d37';
export const PgmntColorFeedbackRedDefault = '#da1e28';
export const PgmntColorFeedbackRed100 = 'rgba(218, 30, 40, 0.08)';
export const PgmntColorFeedbackRedAccessible = '#cc1c25';
export const PgmntColorFeedbackYellowDefault = '#f1c21b';
export const PgmntColorFeedbackYellow100 = 'rgba(241, 194, 27, 0.12)';
export const PgmntColorFeedbackYellowAccessible = '#A86800';

// lv. 2 semantic
export const PgmntColorNeutralTextPrimary = PgmntColorBlack900;
export const PgmntColorNeutralTextSecondary = PgmntColorBlack600;
export const PgmntColorNeutralBackgroundPrimary = PgmntColorGray000;
export const PgmntColorNeutralBackgroundSubtle = PgmntColorBlack100;
export const PgmntColorNeutralBackgroundPageBG = PgmntColorGray050;
export const PgmntColorNeutralBorderDefault = PgmntColorBlack200;
export const PgmntColorNeutralBorderStrong = PgmntColorBlack500;
export const PgmntColorInteractiveTextDefault = PgmntColorBlueDefault;
export const PgmntColorInteractiveTextDefaultHover = PgmntColorBlueDark;
export const PgmntColorInteractiveTextWeak = PgmntColorBlack600;
export const PgmntColorInteractiveTextOnFill = PgmntColorGray000;
export const PgmntColorInteractiveIconSubtle = PgmntColorBlack600;
export const PgmntColorInteractiveBackgroundBold = PgmntColorBlueDefault;
export const PgmntColorInteractiveBackgroundBoldHover = PgmntColorBlueDark;
export const PgmntColorInteractiveBorderBold = PgmntColorBlueDefault;
export const PgmntColorInteractiveBorderStrong = PgmntColorBlack900;
export const PgmntColorInteractiveBorderWeak = PgmntColorBlack500;
export const PgmntColorActivityFocusBorder = PgmntColorBlueDefault;
export const PgmntColorPartnershipTextDefault = PgmntColorRedAccessible;
export const PgmntColorPartnershipTextLargeOrBold = PgmntColorRedDefault;
export const PgmntColorPartnershipBackgroundBold = PgmntColorRedDefault;
export const PgmntColorPartnershipBackgroundSubtle = PgmntColorRed100;
export const PgmntColorFeedbackInfoBold = PgmntColorFeedbackBlueDefault;
export const PgmntColorFeedbackInfoSubtle = PgmntColorFeedbackBlue100;
export const PgmntColorFeedbackDangerBold = PgmntColorFeedbackRedDefault;
export const PgmntColorFeedbackDangerSubtle = PgmntColorFeedbackRed100;
export const PgmntColorFeedbackDangerAccessible =
  PgmntColorFeedbackRedAccessible;
export const PgmntColorFeedbackWarningBold = PgmntColorFeedbackYellowDefault;
export const PgmntColorFeedbackWarningSubtle = PgmntColorFeedbackYellow100;
export const PgmntColorFeedbackWarningAccessible =
  PgmntColorFeedbackYellowAccessible;
export const PgmntColorFeedbackSuccessBold = PgmntColorFeedbackGreenDefault;
export const PgmntColorFeedbackSuccessSubtle = PgmntColorFeedbackGreen100;
export const PgmntColorFeedbackSuccessAccessible =
  PgmntColorFeedbackGreenAccessible;

export const PgmntShadowDropdown = '0px 6px 12px 0px rgba(0,0,0,0.11)';
export const PgmntShadowCardOutline = '0px 0px 0px 1px rgba(0,0,0,0.08)';
export const PgmntShadowCardHover =
  '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 8px 16px -4px rgba(0,0,0,0.2)';
export const PgmntShadowStickyBar =
  '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 4px 12px -4px rgba(0,0,0,0.2)';
export const PgmntShadowPopover = '0px 4px 12px 0px rgba(0,0,0,0.2)';

export const PgmntRadiusCard = '8px';
export const PgmntRadiusThumbnail = '8px';
export const PgmntRadiusAlert = '4px';
export const PgmntRadiusSm = '4px';
